<template>
	<van-popup v-model:show="popupShow" position="bottom" :round="true" closeable @close="handleClose">
		<div class="attr-popup-content">
			<div class="popup-header">
				<span class="title">参数</span>
				<i class="iconfont icon-guanbi" style="color: #c4c6c9; font-size: 1.5rem; cursor: pointer" @click="closeAttrPopup"></i>
			</div>
			<div class="good-attr">
				<div class="line-box">
					<div class="label">计量单位：</div>
					<div class="value">{{ product.measuringUnit }}</div>
				</div>
				<div class="line-box">
					<div class="label">生产国：</div>
					<div class="value">{{ product.countryOfOriginStr }}</div>
				</div>
				<div class="line-box">
					<div class="label">商品编号：</div>
					<div class="value">{{ product.productCode }}</div>
				</div>
				<div class="line-box">
					<div class="label">商品性质：</div>
					<div class="value">{{ product.productNatureStr }}</div>
				</div>
				<div class="line-box">
					<div class="label">规格型号：</div>
					<div class="value">{{ product.specifications }}</div>
				</div>
				<div class="line-box">
					<div class="label">厂家物料编码：</div>
					<div class="value">{{ product.materialCode }}</div>
				</div>
				<div class="line-box">
					<div class="label">风险等级：</div>
					<div class="value">{{ product.riskRankStr }}</div>
				</div>
				<div class="line-box">
					<div class="label">新风险等级：</div>
					<div class="value">{{ formatNewRisk(product.newRiskRank) }}</div>
				</div>
				<div class="line-box">
					<div class="label">注册证号/备案凭证号：</div>
					<div class="value">{{ product.licenseCode }}</div>
				</div>
				<div class="line-box">
					<div class="label">注册人/备案人：</div>
					<div class="value">{{ product.manufacturer }}</div>
				</div>
				<div class="line-box">
					<div class="label">产品分类：</div>
					<div class="value">{{ product.productClassify }}</div>
				</div>
				<div class="line-box">
					<div class="label">新产品分类：</div>
					<div class="value">{{ product.newProductClassify }}</div>
				</div>
				<div class="line-box">
					<div class="label">特殊分类：</div>
					<div class="value">{{ product.specialSortStr }}</div>
				</div>
				<div class="line-box" v-if="product.storageConditionStr">
					<div class="label">储运条件：</div>
					<div class="value">{{ product.storageConditionStr }}</div>
				</div>
				<div class="line-box" v-if="product.productNo">
					<div class="label">产品技术要求编号：</div>
					<div class="value">{{ product.productNo }}</div>
				</div>
			</div>
			<div class="confirm-btn-container">
				<button class="confirm-btn" @click="handleConfirm">确定</button>
			</div>
		</div>
	</van-popup>
</template>

<script setup>
import { ref } from 'vue';
import { NEW_RISK_ENUM } from '@/enum-js/prodcut';

const props = defineProps({
	product: {
		type: Object,
		default: () => ({}),
	},
});

const emit = defineEmits(['confirm', 'close']);

const popupShow = ref(false);

function formatNewRisk(val) {
	return NEW_RISK_ENUM[val] || val;
}

function open() {
	popupShow.value = true;
}

function closeAttrPopup() {
	popupShow.value = false;
}

function handleConfirm() {
	emit('confirm');
	popupShow.value = false;
}

function handleClose() {
	emit('close');
}

defineExpose({ open });
</script>

<style lang="scss" scoped>
.attr-popup-content {
	background-color: #fff;
	border-radius: 7px 7px 0 0;
	padding-bottom: calc(env(safe-area-inset-bottom));
	.popup-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		height: 48px;
		padding: 12px;
		.title {
			flex: 1;
			text-align: center;
			font-size: 18px;
			font-weight: bold;
			color: #333;
		}
	}
	.good-attr {
		width: 100%;
		padding: 0 1.5rem;
		max-height: 60vh;
		overflow-y: auto;
		.line-box {
			width: 100%;
			display: flex;
			flex-direction: row;
			justify-content: space-between;
			margin-top: 2px;
		}
		.label {
			line-height: 24px;
			width: 50%;
			color: #595959;
		}
		.value {
			line-height: 24px;
			width: 50%;
			color: #1f1f1f;
		}
	}
	.confirm-btn-container {
		padding: 8px 12px;
		position: relative;
	}
	.confirm-btn {
		width: 100%;
		height: 43px;
		border-radius: 5px;
		border: none;
		display: flex;
		flex-direction: row;
		justify-content: center;
		padding: 10px 0px;
		background: #455bd9;
		font-size: 16px;
		font-weight: 500;
		text-align: center;
		letter-spacing: 2px;
		color: #ffffff;
		cursor: pointer;
	}
}
</style>
